export default __webpack_public_path__ + "static/media/Rectangle2.8a352f19.png";